/**
 * The web semantic analytics taxonomy: one product-flavoured event name per
 * meaningful conversion moment, fired through {@link trackEvent} which fans it
 * out to GA4 and Facebook Pixel.
 *
 * Every name, its docblock and its Pixel standard/custom decision live in the
 * shared catalog, `packages/core/src/analytics/catalog.ts`; the entries with a
 * `key` are this taxonomy. This module only gives them their web names.
 */
import {
  WEB_PIXEL_EVENT_MAP,
  WEB_TRACKED_EVENTS,
  type AnalyticsMetaEvent,
  type WebTrackedEventName,
} from '@kiao-voice/core/analytics'

export const ANALYTICS_EVENTS = WEB_TRACKED_EVENTS

export type AnalyticsEventName = WebTrackedEventName

/**
 * Facebook Pixel mapping for each semantic event.
 * - `standard: true`  → `fbq('track', name)` (a Pixel standard event Meta can
 *   optimise ad delivery against, e.g. Lead / CompleteRegistration / ViewContent).
 * - `standard: false` → `fbq('trackCustom', name)` (a custom event).
 */
export type PixelEventMapping = AnalyticsMetaEvent

export const PIXEL_EVENT_MAP: Readonly<Record<AnalyticsEventName, PixelEventMapping>> =
  WEB_PIXEL_EVENT_MAP
